<template>
  <!--已处理-->
  <div class="table-page-search-wrapper">
    <a-form :form="form" layout="inline" v-on:keyup.enter="$refs.table.refresh(true)">
      <a-row :gutter="24">
        <a-col :span="6">
          <a-form-item label="订单号">
            <a-input  v-decorator="['orderNo', { rules: [{ required: false, message: '请输入订单号' }] }]"/>
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="问题类型">
            <a-select v-decorator="['matterCode', { rules: [{ required: false, message: '选择' }] }]" >
              <a-select-option value="0">
                投诉类型
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="处理情况">
            <a-select v-decorator="['matterCode', { rules: [{ required: false, message: '选择' }] }]" >
              <a-select-option value="0">
                投诉类型
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="问题内容">
            <a-input  v-decorator="['complainantPhone', { rules: [{ required: false, message: '请输入订单号' }] }]"/>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="6">
          <a-form-item label="申请人">
            <a-input  v-decorator="['currentHandlerName', { rules: [{ required: false, message: '请输入订单号' }] }]"/>
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="当前处理人">
            <a-input  v-decorator="['currentHandlerName', { rules: [{ required: false, message: '请输入订单号' }] }]"/>
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="申请时间">
            <a-range-picker
              :showTime="{ format: 'HH:mm:ss' }"
              format="YYYY-MM-DD HH:mm:ss"
              :placeholder="['开始时间', '结束时间']"
              @change="onChange1"
              @ok="onOk"
              style="width: 300px"
            />
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="处理开始时间">
            <a-range-picker
              :showTime="{ format: 'HH:mm:ss' }"
              format="YYYY-MM-DD HH:mm:ss"
              :placeholder="['开始时间', '结束时间']"
              @change="onChange2"
              @ok="onOk"
              style="width: 280px"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="6">
          <a-form-item label="处理完成时间">
            <a-range-picker
              :showTime="{ format: 'HH:mm:ss' }"
              format="YYYY-MM-DD HH:mm:ss"
              :placeholder="['开始时间', '结束时间']"
              @change="onChange3"
              @ok="onOk"
              style="width: 280px"
            />
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="处理时长">
            <a-range-picker
              :showTime="{ format: 'HH:mm:ss' }"
              format="YYYY-MM-DD HH:mm:ss"
              :placeholder="['开始时间', '结束时间']"
              @change="onChange4"
              @ok="onOk"
              style="width: 300px"
            />
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="总处理时长">
            <a-range-picker
              :showTime="{ format: 'HH:mm:ss' }"
              format="YYYY-MM-DD HH:mm:ss"
              :placeholder="['开始时间', '结束时间']"
              @change="onChange4"
              @ok="onOk"
              style="width: 300px"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="16"></a-col>
        <a-col :span="8">
            <span style="display: flex;justify-content: center;">
              <a-button class="twobtn" type="primary" @click="query()">查询</a-button>
              <a-button class="twobtn" style="margin-left: 35px" @click="() => queryParam = {}">清空</a-button>
            </span>
        </a-col>
      </a-row>
    </a-form>
    <a-table
      size="default"
      ref="table"
      rowKey="modelId"
      :pagination="pagination"
      :loading="loading"
      :columns="columns"
      :data-source="complaintData"
      :scroll="{ x: 3800 }"
      bordered
    >
            <span slot="action" slot-scope="text, record">
              <a v-if="record.statusCode<2" @click="handles(record)">处理</a>
              <a-divider type="vertical" />
              <a v-if="record.statusCode<2" @click="Transfer(record.userId)">转派</a>
                    <a-divider type="vertical" />
              <a v-if="record.statusCode<2" @click="withdraw(record.userId)">撤回</a>
                    <a-divider type="vertical" />
              <a  @click="Resume(record.userId)">履历</a>
            </span>
    </a-table>
  </div>
</template>

<script>
  import { ACCESS_TOKEN } from '@/store/mutation-types'
  export default {
    name: "Processed",
    data(){
      return{
        form: this.$form.createForm(this),
        queryParam:{},
        visible:false,
        confirmLoading:false,
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN)
        },
        // 表头
        columns: [
          {
            title: '序号',
            dataIndex: 'rowNum',
            width: '70px',
            align:'center'
          },
          {
            title: '操作',
            width: '200px',
            dataIndex: 'statusArea',
            scopedSlots: { customRender: 'action' },
            align:'center'
          },
          {
            title: '处理情况',
            dataIndex: 'handlingStatus',
            align:'center'
          },
          {
            title: '投诉类型',
            dataIndex: 'matterName',
            align:'center'
          },
          {
            title: '订单号',
            dataIndex: 'orderNo',
            align:'center'
          },
          {
            title: '企业名称',
            dataIndex: 'enterpriseName',
            align:'center'
          },
          {
            title: '市场负责人',
            dataIndex: 'marketPrincipalName',
            align:'center'
          },
          {
            title: '订单状态',
            dataIndex: 'orderStatus',
            align:'center'
          },
          {
            title: '订单子状态',
            dataIndex: 'orderSubStatusName',
            align:'center'
          },
          {
            title: '投诉人',
            dataIndex: 'complainantName',
            align:'center'
          },
          {
            title: '投诉人联系方式',
            dataIndex: 'complaintPhone',
            align:'center'
          },
          {
            title: '投诉内容',
            dataIndex: 'contents',
            align:'center'
          },
          {
            title: '投诉对象',
            dataIndex: 'complaintObjectName',
            align:'center'
          },
          {
            title: '被投诉人',
            dataIndex: 'respondentName',
            align:'center'
          },
          {
            title: '投诉时间',
            dataIndex: 'createTime',
            align:'center'
          },
          {
            title: '安装类别',
            dataIndex: 'installTypeName',
            align:'center'
          },
          {
            title: '订单类型',
            dataIndex: 'orderTypeName',
            align:'center'
          },
          {
            title: '客户姓名',
            dataIndex: 'clientName',
            align:'center'
          },
          {
            title: '客户电话',
            dataIndex: 'clientPhone',
            align:'center'
          },
          {
            title: '订单负责人',
            dataIndex: 'orderPrincipalName',
            align:'center'
          },
          {
            title: '当前协助人',
            dataIndex: 'helperName',
            align:'center'
          },
          {
            title: '师傅姓名',
            dataIndex: 'workName',
            align:'center'
          },
          {
            title: '师傅联系方式',
            dataIndex: 'workPhone',
            align:'center'
          },
          {
            title: '师傅负责人姓名',
            dataIndex: 'masterLeadingName',
            align:'center'
          },
          {
            title: '当前处理人姓名',
            dataIndex: 'currentHandlerName',
            align:'center'
          },
          {
            title: '处理时长',
            dataIndex: 'processingTimeInfo',
            align:'center'
          },
          {
            title: '开始处理时间',
            dataIndex: 'handleStartTime',
            align:'center'
          },
          {
            title: '总处理时长',
            dataIndex: 'totalProcessingTimeInfo',
            align:'center'
          }
        ],
        pagination: false,
        loading: false,
        complaintData:[],
        querytime:{}
      }
    },
    methods:{
      //投诉时间
      onChange1(date, dateString){
        console.log(dateString[0],dateString[1])
        this.querytime.complaintTimeStart=dateString[0]
        this.querytime.complaintTimeEnd=dateString[1]
      },
      //开始处理时间
      onChange2(date, dateString){
        this.querytime.handleStartTimeStart=dateString[0]
        this.querytime.handleStartTimeEnd=dateString[1]
      },
      //处理完成时间
      onChange3(date, dateString){
        this.querytime.handleEndTimeStart=dateString[0]
        this.querytime.handleEndTimeEnd=dateString[1]
      },
      //处理时长
      onChange4(date, dateString){
        this.querytime.processingTimeStart=dateString[0]
        this.querytime.processingTimeEnd=dateString[1]
      },
      //查询
      query(){
        this.form.validateFields((err, values) => {
          console.log(values)
          values.isMyCreate=1
          values.complaintTimeStart= this.querytime.complaintTimeStart
          values.complaintTimeEnd=this.querytime.complaintTimeEnd
          values.handleStartTimeStart= this.querytime.handleStartTimeStart
          values.handleStartTimeEnd= this.querytime.handleStartTimeEnd
          values.handleEndTimeStart= this.querytime.handleEndTimeStart
          values.handleEndTimeEnd= this.querytime.handleEndTimeEnd
          values.processingTimeStart=this.querytime.processingTimeStart
          values.processingTimeEnd= this.querytime.processingTimeEnd
          this.$axios({
            method: "post",
            url: "/api/backlog/complaints/getComplaintsList",
            data:values,
            headers: {
              token: Vue.ls.get(ACCESS_TOKEN),
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }).then((res) => {
            this.complaintData=res.data.rows
          })
        })

      },
    },
    created(){
      //获取投诉列表数据
      // this.$axios({
      //   method: "post",
      //   url: "/api/backlog/complaints/getComplaintsList",
      //   data: {
      //     "isMyCreate":"1"
      //   },
      //   headers: {
      //     token: Vue.ls.get(ACCESS_TOKEN),
      //     'Content-Type': 'application/json;charset=UTF-8'
      //   }
      // }).then((res) => {
      //   this.complaintData=res.data.rows
      //   console.log(res.data.rows)
      // })
    }
  }
</script>

<style scoped>
  /deep/ .ant-table th { white-space: nowrap; }
  /deep/ .ant-table td { white-space: nowrap; }
  /deep/ .ant-table td {  padding: 4px 16px;}
</style>